/*
 * @Author: ZJJ
 * @Date: 2024-03-01 14:25:35
 * @LastEditTime: 2024-03-12 09:47:09
 * @FilePath: /car-activitys/src/android/messager.js
 * @Description: 用于H5与客户端双向通信
 */

class MessengerJs {
  static listeners = {};
  constructor() {
    this.sendMessage = {}; //向客户端发送消息，

    //所有可接收的消息类型
    // ["playStatus", "collect", "theme", "token"];
    //所有发送的消息类型
    // this.sendTypes = ["play","pause","collect","recharge"]; //H5ToApp，发送类型，播放、暂停、收藏、充值
  }

  // H5函数维护
  // 客户端向H5发送请求, 根据type值，确定调用H5哪一个方法
  sendAPPObject(param) {
    if (param.type) {
      this.operateReceiveMessage(param);
    } else {
      console.log("活动页中无此函数");
    }
  }

  operateReceiveMessage(params) {
    // console.log("H5 接收数据", params);
    this.emit(params.type, params);
  }

  // 客户端函数维护    //////////////////////////////////////////////////////////
  // H5向客户端发送消息
  sendH5Object(param) {
    // console.log("window 下是否含有 wanosApp", window.wanosApp, "param", param);
    if (window.wanosApp) {
      // console.log("向 app 发送数据", param);
      window.wanosApp.sendH5Object(JSON.stringify(param));
    }
  }

  //绑定回调事件
  on(type, callback) {
    if (!MessengerJs.listeners[type]) {
      MessengerJs.listeners[type] = [];
    }
    MessengerJs.listeners[type].push(callback);
  }

  /**
   * 移除某个事件的一个监听者
   * @param {String} type 事件类型
   * @param {Function} callback 回调函数
   */
  off(type, callback) {
    if (MessengerJs.listeners[type]) {
      // 查询传入回调函数在该事件类型数组中的下标，并将其下标用targetIndex存储
      const targetIndex = MessengerJs.listeners[type].findIndex(
        item => item === callback
      );
      if (targetIndex !== -1) {
        // 说明该回调函数存在于事件类型数组中
        MessengerJs.listeners[type].splice(targetIndex, 1); // 删除该回调函数
      }
      if (MessengerJs.listeners[type].length === 0) {
        // 该事件类型数组为空
        delete MessengerJs.listeners[type]; // 删除该事件类型
      }
    }
  }

  emit(type, ...args) {
    if (MessengerJs.listeners[type]) {
      // 如果该事件类型存在
      MessengerJs.listeners[type].forEach(callback => {
        callback(...args); // 调用该事件类型数组中的每一个回调函数，并传入参数
      });
    }
  }
}

export { MessengerJs };
